import { useParams } from 'react-router';
import { DetailPageStatus } from '@/components/detail/DetailPageStatus';
import { TimeSheetDetailView } from '@/components/timesheet/TimeSheetDetail';
import { loadTimeSheetDetail } from '@/components/timesheet/timeSheetDetailData';
import { useFollowEntityCompany } from '@/hooks/useFollowEntityCompany';
import { useLoader } from '@/hooks/useLoader';

/**
 * Feuille d'un collaborateur depuis le récapitulatif d'une période (/history/{période}/sheets/{feuille}) : le détail
 * partagé avec la Validation et Mes demandes (TimeSheetDetailView), en lecture seule (période clôturée, feuilles
 * validées). Sous-page de l'Historique : mêmes droits (Dirigeant de la société), retour au récapitulatif.
 */
export function HistorySheetPage() {
  const { id = '', sheetId = '' } = useParams();
  const { data, error, loaded } = useLoader(sheetId, loadTimeSheetDetail);
  const back = {
    to: `/history/${id}`,
    label: data ? `Récapitulatif de ${data.period.monthLabel.toLowerCase()}` : 'Récapitulatif de la période',
  };

  useFollowEntityCompany(data?.period.companyId, '/history');

  if (!data) {
    return <DetailPageStatus back={back} loaded={loaded} error={error} notFound="Feuille introuvable." />;
  }

  return <TimeSheetDetailView data={data} back={back} title={`${data.sheet.fullName} — ${data.period.monthLabel}`} />;
}
